"use client";var e="@sainsburys-tech/fable",s="4.17.1";export{e as name,s as version};
